/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Spaces_Webhook_Address_DescriptionInputs */



/**
* | output |
* | --- |
* | "For live updates, add this address as a webhook in {name}, with the same signing secret you entered here." |
*
* @param {Spaces_Webhook_Address_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_webhook_address_description = /** @type {((inputs: Spaces_Webhook_Address_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Webhook_Address_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Für Live-Updates trägst du diese Adresse in ${i?.name} als Webhook ein, mit demselben Signatur-Geheimnis, das du hier eingegeben hast.`)
	return /** @type {LocalizedString} */ (`For live updates, add this address as a webhook in ${i?.name}, with the same signing secret you entered here.`)
});